/** Hardcoded choices for the create-box form.
 *  The backend accepts free-form strings for instance type and OS version, and
 *  exposes no discovery endpoint yet — these lists are the frontend's own and
 *  should be replaced once the API can enumerate them. */
import type { Ec2Arch, Ec2OS } from './types';

export interface Choice {
  value: string;
  label: string;
}

export const OPERATING_SYSTEMS: { value: Ec2OS; label: string }[] = [{ value: 'Ubuntu', label: 'Ubuntu' }];

export const OS_VERSIONS: Record<Ec2OS, Choice[]> = {
  Ubuntu: [
    { value: '24.04', label: '24.04 LTS (Noble Numbat)' },
    { value: '22.04', label: '22.04 LTS (Jammy Jellyfish)' },
  ],
};

export const ARCHITECTURES: { value: Ec2Arch; label: string }[] = [
  { value: 'X86_64', label: 'x86_64 (Intel/AMD)' },
  { value: 'Arm64', label: 'arm64 (Graviton)' },
];

export const INSTANCE_TYPES: Record<Ec2Arch, Choice[]> = {
  Arm64: [
    { value: 't4g.small', label: 't4g.small — 2 vCPU · 2 GiB · burstable' },
    { value: 't4g.medium', label: 't4g.medium — 2 vCPU · 4 GiB · burstable' },
    { value: 't4g.large', label: 't4g.large — 2 vCPU · 8 GiB · burstable' },
    { value: 't4g.xlarge', label: 't4g.xlarge — 4 vCPU · 16 GiB · burstable' },
    { value: 'm7g.large', label: 'm7g.large — 2 vCPU · 8 GiB · general purpose' },
    { value: 'm7g.xlarge', label: 'm7g.xlarge — 4 vCPU · 16 GiB · general purpose' },
    { value: 'c7g.xlarge', label: 'c7g.xlarge — 4 vCPU · 8 GiB · compute' },
    { value: 'r7g.xlarge', label: 'r7g.xlarge — 4 vCPU · 32 GiB · memory' },
  ],
  X86_64: [
    { value: 't3.medium', label: 't3.medium — 2 vCPU · 4 GiB · burstable' },
    { value: 't3.large', label: 't3.large — 2 vCPU · 8 GiB · burstable' },
    { value: 't3.xlarge', label: 't3.xlarge — 4 vCPU · 16 GiB · burstable' },
    { value: 'm7i.large', label: 'm7i.large — 2 vCPU · 8 GiB · general purpose' },
    { value: 'm7i.xlarge', label: 'm7i.xlarge — 4 vCPU · 16 GiB · general purpose' },
    { value: 'c7i.xlarge', label: 'c7i.xlarge — 4 vCPU · 8 GiB · compute' },
    { value: 'r7i.xlarge', label: 'r7i.xlarge — 4 vCPU · 32 GiB · memory' },
  ],
};

export const STACK_TYPES: Choice[] = [{ value: 'DockerCompose', label: 'Docker Compose' }];
